export enum ClassificationApiName {
  EPISODE = 'episode',
  PLAN_TYPE = 'plan_type',
  HEALTH_PLAN = 'health_plan',
}

export enum ClassificationClass {
  EPISODE = 'Classification::Episode',
  PLAN_TYPE = 'Classification::PlanType',
  HEALTH_PLAN = 'Classification::HealthPlan',
}

export interface ClassificationOptions {
  id: string;
  name: string;
  type: string;
  parentClassification?: ClassificationOptions;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

function getDefaults(): ClassificationOptions {
  return {
    id: '',
    name: '',
    type: ClassificationClass.PLAN_TYPE,
  };
}

/**
 * @class Classification
 * @classdesc Represents a classification in the system
 * @property {string} id - The classification's id
 * @property {string} name - The classification's name
 * @property {string} type - The classification's type
 * @property {string | Date} createdAt - The classification's creation date
 * @property {string | Date} updatedAt - The classification's update date
 * @param {Partial<ClassificationOptions>} [options={}]
 */
export default class Classification {
  id: string;
  name: string;
  type: string;
  parentClassification?: Classification;
  createdAt?: string | Date;
  updatedAt?: string | Date;

  constructor(options: Partial<ClassificationOptions> = {}) {
    const opts = { ...getDefaults(), ...options };
    this.id = opts.id;
    this.name = opts.name;
    this.type = classificationType(opts.type)!;
    this.parentClassification = opts.parentClassification ? new Classification(opts.parentClassification) : undefined;
    this.createdAt = opts.createdAt;
    this.updatedAt = opts.updatedAt;
  }

  get isPlanType() {
    return this.type === ClassificationApiName.PLAN_TYPE;
  }

  get isEpisode() {
    return this.type === ClassificationApiName.EPISODE;
  }

  serialize() {
    return {
      id: this.id,
      name: this.name,
      type: classificationClass(this.type),
      parentClassification: this.parentClassification?.serialize(),
    };
  }
}

export const classificationType = (type: string) => {
  switch (type) {
    case ClassificationClass.PLAN_TYPE:
      return ClassificationApiName.PLAN_TYPE;
    case ClassificationClass.EPISODE:
      return ClassificationApiName.EPISODE;
  }
};

const classificationClass = (type: string) => {
  switch (type) {
    case ClassificationApiName.PLAN_TYPE:
      return ClassificationClass.PLAN_TYPE;
    case ClassificationApiName.EPISODE:
      return ClassificationClass.EPISODE;
  }
};
